import React,{useState} from 'react'
import { HiOutlineMail } from "react-icons/hi"
import { HiOutlineLocationMarker } from "react-icons/hi"
import { TbPhone } from "react-icons/tb"
import { FiFacebook } from "react-icons/fi"
import { FaInstagram } from "react-icons/fa"
import { RxTwitterLogo } from "react-icons/rx"
import { FaLinkedinIn } from "react-icons/fa"

const Contact = () => {

    const [name, setName] = useState()
    const [phone, setPhone] = useState()
    const [email, setEmail] = useState()
    const [message, setMessage] = useState()
    const [sucess, setSucess] = useState(false)

   
     const handleClick = () =>{

        setSucess(false)

        fetch('https://sheetdb.io/api/v1/12glnim8pn63s', {
    method: 'POST',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        data: [
            {
                Name : name,
                Phone : phone,
                Email : email,
                Message : message
            }
        ]
    })
})
  .then((response) => response.json())
  .then((data) => {
    data.created > 0 && setSucess(true)
  });
     }
  

    return (
        <div  className='mt-4'>
            <div style={{ width: "50%" }} className='text-white border-r h-20 mb-8'></div>
            <p className='text-white flex justify-center'>SOME OF THE WORKS</p>
            <h2 className='border-l-0 pl-0 text-center'>
                LET'S CONNECT <span>WITH US</span>
            </h2>


            <div id='contact' className='flex justify-around mt-8 mb-16'>
                <div id='contact-1' style={{width:"40%"}}>
                    <h2 id='form-title' className='text-white'>Get In Touch</h2>
                    <div id='form' className='flex flex-wrap'>
                        <p className='w-2/5'>
                            Name<br />
                            <input className='bg-gray-200 px-4' value={name} onChange={(e)=> setName(e.target.value)} onClick={()=> setSucess(false)}/>
                        </p>
                        <p  className='w-2/5'>
                            Phone-Number<br />
                            <input className='bg-gray-200 px-4' value={phone} onChange={(e)=> setPhone(e.target.value)} onClick={()=> setSucess(false)}/>
                        </p>
                        <p style={{width:"85%"}}>
                            Email<br />
                            <input className='bg-gray-200 px-4' value={email} onChange={(e)=> setEmail(e.target.value)} onClick={()=> setSucess(false)}/>
                        </p>
                        <p style={{width:"85%"}}>
                            Message<br />
                            <textarea className='bg-gray-200 h-40 w-full px-4 py-2' value={message} onChange={(e)=> setMessage(e.target.value)} onClick={()=> setSucess(false)}/>
                        </p>

                        {
                            sucess && <p style={{width:"85%"}}>Your Data Submited Sucessfully</p>
                        }


                        <div id="contact-btn">
                        <p id='about-btn' style={{color:"black" , margin:"1.5rem 1.5rem"}} className='text-black '
                        onClick={()=> handleClick()}
                        >Submit</p>
                        </div>
                    </div>

                   <div id='form-2'>
                     <input placeholder='Name' className=' text-center px-4 my-2'/>
                     <input placeholder='Phone Number' className='text-center px-4 my-2'/>
                     <input placeholder='Email' className='text-center px-4 my-2'/>
                     <textarea className=' h-40 w-full text-center py-2 px-4 my-2' placeholder='Message'/>
                   
                     <div id="contact-btn">
                        <p id='about-btn' style={{color:"black" , margin:"1.5rem 1.5rem"}} className='text-black '>Submit</p>
                        </div>
                   
                   </div>

                </div>




                <div id='contact-temp' className='w-2/5'>
                    <div>
                        <h2 id='contact-h2' className='border-l-0'>
                            Contact Details
                        </h2>
                        <p className='text-white'>Thank you for visiting our website. If you have a project, let's discuss!</p>


                        <p id='address' className='text-white items-start flex '>
                            <HiOutlineLocationMarker size={40} className='mr-5'/>
                            G-4, CED Building, IBA Main Campus,
                            Karachi University.
                        </p>
                        <p className='text-white items-start flex '>
                            <HiOutlineMail size={30} className='mr-5' />
                             info@vwrap.com
                        </p>
                        <p className='text-white items-start flex '>
                            <TbPhone size={30} className='mr-5' />
                            0300-2837111  -  0318-2088984
                        </p>

                       <p className='text-white mt-8'>Follow Us</p>
                       <p id='icon-containers' className='flex text-white'>
                        <FiFacebook size={25} className='mr-1' />
                        <FaInstagram size={25} className='mx-2' />
                        <RxTwitterLogo size={25} className='mx-2' />
                        <FaLinkedinIn size={25} className='mx-2' />
                       </p>


                    </div>
                </div>
            </div>


        </div>
    )
}

export default Contact
